<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><a id="page_4"></a>Text copyright © 2017 by Jill O’Connor.</p>
<p>Photographs copyright © 2017 by Leigh Beisch.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>ISBN 9781452153940 (epub, mobi)</p>
<p>Library of Congress Cataloging-in-Publication Data:</p>
<p>Names: O’Connor, Jill, author.<br/>Title: Cake, I love you : decadent, delectable, and do-able recipes / Jill O’Connor.<br/>Description: San Francisco : Chronicle Books, 2017. | Includes index.<br/>Identifiers: LCCN 2016025898 | ISBN 9781452153803 (hardback)<br/>Subjects: LCSH: Cake. | BISAC: COOKING / Methods / Baking. | COOKING / Courses &amp; Dishes / Cakes. | LCGFT: Cookbooks.<br/>Classification: LCC TX771.O29 2017 | DDC 641.86/53—dc23 LC record available at <a href="https://lccn.loc.gov/2016025898" target="_blank">https://lccn.loc.gov/2016025898</a></p>
<p>Designed by Alice Chau.<br/>Illustrations by Jordan Sondler.</p>
<p>Food styling by Robyn Valarik.<br/>Prop styling by Sara Slavin.</p>
<p>Chronicle books and gifts are available at special quantity discounts to corporations, professional associations, literacy programs, and other organizations. For details and discount information, please contact our premiums department at <a href="mailto:corporatesales@chroniclebooks.com">corporatesales@chroniclebooks.com</a> or at 1-800-759-0190.</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank">www.chroniclebooks.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04copyright.vue?4c64115a